import React, { useEffect, useState } from "react";

import DefaultFooter from "../CommonUtils/DefaultFooter";
import { s360ConfigService } from "../Services/S360Config";

import InitialChannelFormDetails from "./InitialChannelFormDetails";
// import InitialContactFormDetails from "./InitialContactFormDetails";
import InitialFormDetails from "./InitialFormDetails";
import InitialOfflinePage from "./InitialOfflinePage";

import './InitialFormStyleSheet.css';

function InitialFormContainer(props) {
  // const [setShowForm] = useState(false);
  const [setShowContactForm] = useState(false);
  const [showChannels, setShowChannels] = useState(false);
  
  const showLandingPage = () => {
    setShowContactForm(false);
    setShowChannels(false);
  }
  const ComponentsForForm = {
    offlineForm: "offlineForm",
    mainForm: "mainForm",
    channels: "channels",
  }
  useEffect(()=>{
    setShowChannels(s360ConfigService?.config?.configDetails?.showChannels)
  },[s360ConfigService?.config?.configDetails?.showChannels])

  const DecideFormComponent = () => {
    const config = s360ConfigService?.config;
    console.log(config?.configDetails, "config1234")
    if (config?.configDetails?.offline) {
      return ComponentsForForm.offlineForm
    }
    else if (config?.channels && showChannels) {
      return ComponentsForForm.channels
    }
    else if (!showChannels) {
      return ComponentsForForm?.mainForm
    }
    

  }
  console.log(DecideFormComponent(), "DecideFormComponent")
  return (
    <div className="S360-initial-form-detail-container-parent">
      <div className="s360-initial-form-detail-container" style={{ overflowY: 'auto' }}>
        {DecideFormComponent() === ComponentsForForm.offlineForm && (
          <InitialOfflinePage
            handleRedirect={() => setShowChannels(false)}
            handleContactForm={() => setShowContactForm(true)}
            actions={props.actions}
          />
        )}
        {DecideFormComponent() === ComponentsForForm.mainForm && (
          <InitialFormDetails {...props} showLandingPage={showLandingPage} />
        )}
        {DecideFormComponent() === ComponentsForForm.channels && (
          <InitialChannelFormDetails
            {...props}
            handleRedirect={() => {

              setShowChannels(false)
            }}
            handleContactForm={() => setShowContactForm(true)}
          />
        )}

        <DefaultFooter {...props} />
      </div>
    </div>
  );
}

export default InitialFormContainer;
